import * as Actions from "../actions";

const initialState = {
  success: false,
  data: null,
  isFetchingCaptcha: false,
  error: null,
};

const captcha = function (state = initialState, action) {
  switch (action.type) {
    case Actions.CAPTCHA_FETCH_START: {
      return {
        ...initialState,
        isFetchingCaptcha: true,
      };
    }
    case Actions.CAPTCHA_FETCH_SUCCESS: {
      return {
        ...initialState,
        success: true,
        data: action.payload,
        isFetchingCaptcha: false,
      };
    }
    case Actions.CAPTCHA_FETCH_FAILURE: {
      return {
        success: false,
        isFetchingCaptcha: false,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default captcha;
